import { useCallback, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { TablePaginationConfig } from 'antd'
import { Task } from '../types'
import { createCleanSearchParams } from '../utils'

export const useTasksTable = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handlerTableChange = useCallback(
    async (pagination: TablePaginationConfig, _filters: any, sorter: any) => {
      const currentUrlParams = Object.fromEntries(new URLSearchParams(location.search))
      const current: any = {
        ...currentUrlParams,
        sort_order: sorter?.order,
        sort_field: sorter?.field,
        page: pagination.current,
      }

      // Удаляем значения по умолчанию для чистого URL
      if (current?.page === 1) {
        delete current.page
      }

      if (current?.sort_order === undefined || current?.sort_order === null) {
        delete current.sort_order
        delete current.sort_field
      }

      // Очищаем пустые параметры
      const searchParams = createCleanSearchParams(current)
      navigate({ search: searchParams.toString() })
      // НЕ вызываем getData() - данные перезагрузятся автоматически через useEffect в useTasksData
    },
    [navigate, location.search],
  )

  const cbTableRowClick = useCallback(
    (item: Task) => {
      const getPrefix = (type: string): string => {
        if (type === 'case') return 'order'
        if (type === 'claim_work') return 'claim-work'
        return type
      }
      const prefix = getPrefix(item.card_type)
      const cardId = item.card_id
      return navigate(`/${prefix}/${cardId}`)
    },
    [navigate],
  )

  const rowClassName = useCallback((record: Task) => {
    return `table-row-${record.stage}`
  }, [])

  const excelPath = useMemo(() => {
    const getPrintPath = (path: string, params: URLSearchParams) => `${path}?${params.toString()}`
    return getPrintPath('/api/v2/tasks', new URLSearchParams(location.search))
  }, [location.search])

  return {
    handlerTableChange,
    cbTableRowClick,
    rowClassName,
    excelPath,
  }
}
